// utils/tiktokPixel.js

export const loadTikTokPixel = (pixelIds = []) => {
  if (!Array.isArray(pixelIds) || pixelIds.length === 0) return;

  // Initialize global TikTok object if not already present
  if (!window.ttq) {
    (function (w, d, t) {
      w.TiktokAnalyticsObject = t;
      var ttq = (w[t] = w[t] || []);
      ttq.methods = [
        "page",
        "track",
        "identify",
        "instances",
        "debug",
        "on",
        "off",
        "once",
        "ready",
        "alias",
        "group",
        "enableCookie",
        "disableCookie",
        "holdConsent",
        "revokeConsent",
        "grantConsent",
      ];
      ttq.setAndDefer = function (t, e) {
        t[e] = function () {
          t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
        };
      };
      for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
      ttq.instance = function (t) {
        for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++)
          ttq.setAndDefer(e, ttq.methods[n]);
        return e;
      };
      ttq.load = function (e, n) {
        const r = "https://analytics.tiktok.com/i18n/pixel/events.js";
        ttq._i = ttq._i || {};
        ttq._i[e] = [];
        ttq._o = ttq._o || {};
        ttq._o[e] = n || {};
        const s = d.createElement("script");
        s.type = "text/javascript";
        s.async = true;
        s.src = r + "?sdkid=" + e + "&lib=" + t;
        const f = d.getElementsByTagName("script")[0];
        f.parentNode.insertBefore(s, f);
      };
    })(window, document, "ttq");
  }

  // Load each pixel only once
  pixelIds.forEach((pixelId) => {
    if (window.ttq._i && window.ttq._i[pixelId]) {
      console.log(`TikTok Pixel ${pixelId} already initialized`);
      return;
    }
    window.ttq.load(pixelId);
    window.ttq.page();
    console.log(`TikTok Pixel loaded: ${pixelId}`);
  });
};

// 🔹 Track a TikTok event for a single service (based on ID)
export const trackTikTokEvent = (pixelId, eventName, eventParams = {}) => {
  try {
    if (!window.ttq || !window.ttq._i || !pixelId) {
      console.warn("TikTok Pixel not initialized or missing ID");
      return;
    }

    const instance = window.ttq.instance(pixelId);
    if (typeof instance.track === "function") {
      instance.track(eventName, eventParams);
      console.log(`TikTok event '${eventName}' fired for pixel ${pixelId}`, eventParams);
    } else {
      console.warn(`TikTok instance not ready for pixel ${pixelId}`);
    }
  } catch (err) {
    console.error("Error tracking TikTok event:", err);
  }
};
